import { datadogRum } from '@datadog/browser-rum';
import { currentUser } from './currentUser';
import { currentApplication } from './currentApplication';
import { currentClient } from './currentClient';

const ENV_PROD = 'prod';

export function initMonitoring() {
    const envMatch = window.location.hostname.match(/\.alli(?<env>[^.]+)\.com/);

    let env = ENV_PROD;
    if (
        envMatch.groups?.env &&
        envMatch.groups.env.toLowerCase() !== 'platform'
    ) {
        env = envMatch.groups.env.toLowerCase();
    }

    const allowedTraceDomain =
        ENV_PROD === env ? 'alliplatform\\.com' : `alli${env}\\.com`;
    const allowedTracingUrls = [
        new RegExp(`^https://(?!dashboards).+\.${allowedTraceDomain}/`),
    ];

    datadogRum.init({
        clientToken: 'pub7924aba8fbc240e8ef5e45dc9e9f7dcf',
        applicationId: '85cee5a6-a0cf-4448-85e0-959b54ee92ac',
        site: 'datadoghq.com',
        service: 'alli-ui',
        env,
        // can't do version until datadog has better microfrontend support
        //version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        actionNameAttribute: 'data-alli-id',
        allowedTracingUrls,
    });

    const userSub = currentUser.subscribe(user => {
        if (user) {
            datadogRum.setUser({
                id: user.id,
                email: user.email,
            });
        }
    });

    const clientSub = currentClient.subscribe(client => {
        if (client) {
            datadogRum.setGlobalContextProperty('alli_client', client.slug);
        }
    });

    const appSub = currentApplication.subscribe(app => {
        if (app) {
            datadogRum.setGlobalContextProperty(
                'alli_application',
                app.monitoringId,
            );
        }
    });

    return () => {
        userSub.unsubscribe();
        clientSub.unsubscribe();
        appSub.unsubscribe();
    };
}

export function trackError(error, context) {
    datadogRum.addError(error, context);
}

export function trackAction(name, context) {
    datadogRum.addAction(name, context);
}
